// extracted by mini-css-extract-plugin
export default {"list":"RoleForm_list__6DoOm"};